import React from "react";

const amount = (value) => Number(value || 0);

const Deduction = ({ label, value }) =>
  amount(value) > 0 ? (
    <div className="subtotal-statement" data-testid="iyka-policy-deduction">
      <p>{label}</p>
      <p
        style={{
          color: "var(--rms-v2-danger)",
          fontWeight: "500",
          marginLeft: "1rem",
          whiteSpace: "nowrap",
        }}
      >
        − ₹ {amount(value).toFixed(2)}
      </p>
    </div>
  ) : null;

export const isIykaPolicyQuote = (paymentDetails) =>
  paymentDetails?.pricing_breakdown?.version === "iyka-v1";

export const IykaRefundBreakdown = ({ paymentDetails }) => {
  if (!isIykaPolicyQuote(paymentDetails)) return null;
  const policy = paymentDetails.pricing_breakdown;
  const discountAdjustment = Math.max(
    0,
    amount(policy.retained_basis) - amount(policy.retained_discounted),
  );
  const isCredit = policy.refund_method === "shopify_store_credit";

  return (
    <>
      <Deduction label="Offer adjustment" value={discountAdjustment} />
      <Deduction label="Original shipping adjustment" value={policy.shipping_recovery} />
      <Deduction label="Repeat pickup charge" value={policy.pickup_fee} />
      {policy.pickup_fee_provisional && amount(policy.pickup_fee) > 0 ? (
        <p className="iyka-policy-note">
          The pickup charge is based on the planned pickup and will be verified
          when the pickup is created.
        </p>
      ) : null}
      <p className="iyka-policy-note" data-testid="iyka-refund-timing">
        {isCredit
          ? "Store credit is issued after pickup completion and expires after 90 days."
          : "Cash refund is initiated 24–48 hours after pickup completion."}
      </p>
    </>
  );
};
